import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'

import { RequireAuth } from '../core/AccountProvider'
import theme from '../theme'
import AccountAccordion from './AccountAccordion'
import DesktopHeader from './DesktopHeader'
import EquipmentAccordion from './EquipmentAccordion'
import ItemsForSaleAccordion from './ItemsForSaleAccordion'
import MobileHeader from './MobileHeader'
import { buildClient } from '../core/http-common'

export default () => {
  const client = useQueryClient()
  const [activeAccordion, setActiveAccordion] = useState('')
  const [showFilter, setShowFilter] = useState(false)
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    window.addEventListener('logout', () => {
      buildClient()
      client.refetchQueries('accounts')
    })

    window.addEventListener('route', () => {
      setActiveAccordion('')
      handleShowFilter(window.location.pathname)
    })
    handleShowFilter(window.location.pathname)
  }, [])

  const handleActiveAccordion = accordion => {
    if (activeAccordion === accordion) {
      return setActiveAccordion('')
    }

    setActiveAccordion(accordion)
  }

  const handleShowFilter = location => {
    const parts = location.split('/')
    let shouldShowFilter = false

    for (let part of parts) {
      if (part == 'item' || part == 'results') {
        shouldShowFilter = false
        break
      }
      if (['search', 'auction', 'seller', 'landing', 'sellerAlt'].includes(part)) {
        shouldShowFilter = true
      }
    }

    setShowFilter(shouldShowFilter)
  }

  return (
    <>
      {mobileView ? (
        <>
          <MobileHeader
            handleAccountAccordion={() => handleActiveAccordion('account')}
            handleItemsForSaleAccordion={() => handleActiveAccordion('itemsForSale')}
            handleEquipmentAccordion={() => handleActiveAccordion('equipment')}
            showFilter={showFilter}>
            <ItemsForSaleAccordion expanded={activeAccordion === 'itemsForSale'} />
          </MobileHeader>
          <RequireAuth>
            <AccountAccordion expanded={activeAccordion === 'account'} />
          </RequireAuth>
        </>
      ) : (
        <DesktopHeader handleEquipmentAccordion={() => handleActiveAccordion('equipment')} />
      )}

      <EquipmentAccordion expanded={activeAccordion === 'equipment'} />
    </>
  )
}
